import { type EquipmentSize } from '../domain/EquipmentSize'
import { type EquipmentType } from '../domain/EquipmentType'
import { getEquipmentType } from './equipmentTypePresenter'

type AllEquipmentSizes = {
  [key in EquipmentSize]?: string
}

const equipmentSizes: AllEquipmentSizes = {
  '20 ft Standard': "20' STD",
  '40 ft Standard': "40' STD",
  '40 ft High Cube': "40' HC",
  '45 ft High Cube': "45' HC",
}

export function getEquipmentSize(equipmentSize?: EquipmentSize) {
  if (equipmentSize) {
    return equipmentSizes[equipmentSize] || ''
  }

  return ''
}

export function getEquipmentTypeAndSizeLabel(
  type: EquipmentType,
  size: EquipmentSize | undefined,
  showSize: boolean
) {
  const equipmentType = getEquipmentType(type)
  const equipmentTypeLabel = equipmentType ? equipmentType.label : type

  const equipmentSize = getEquipmentSize(size)
  const equipmentSizeLabel = showSize && equipmentSize ? `, ${equipmentSize}` : ''

  return `${equipmentTypeLabel}${equipmentSizeLabel}`
}
